import { render, staticRenderFns } from "./CustomerRegisteredDetail.vue?vue&type=template&id=2906b1ac&scoped=true"
import script from "./CustomerRegisteredDetail.vue?vue&type=script&lang=js"
export * from "./CustomerRegisteredDetail.vue?vue&type=script&lang=js"
import style0 from "./CustomerRegisteredDetail.vue?vue&type=style&index=0&id=2906b1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2906b1ac",
  null
  
)

export default component.exports